import AreaCodeSelect from './src/main';

/* istanbul ignore next */
AreaCodeSelect.install = function(Vue) {
  Vue.component(AreaCodeSelect.name, AreaCodeSelect);
};

export default AreaCodeSelect;
